import React, { useEffect } from "react";
import { ProductsData } from "../models/types";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Box, Card, CardContent, CardMedia, Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import { ErrorOutline } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      display: 'block',
      height: '100%',
      transition: "max-height 0.15s ease-out",
      border: '1px solid #ebdcc6',
      boxShadow: 'none',
    },
    title: {
      marginBottom: 2,
      minHeight: '44px',
      fontSize: '11px',
      fontWeight: 'bold',
      color: 'black',
      lineHeight: 1.3,
    },
    manufacture: {
      marginBottom: 2,
      minHeight: '18px',
      fontSize: '11px',
      color: '#afafaf',
    },
    price: {
      minHeight: '20px',
      marginBottom: 5,
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#597eb2',
    },
    priceDiscount: {
      height: '20px',
      marginBottom: 5,
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#b14f50',
    },
    available: {
      height: '30px',
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#4da451',
    },
    notAvailable: {
      height: '30px',
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#b14f50',
    },
    iconText: {
      paddingBottom: 5,
    },
    pos: {
      marginBottom: 12,
      color: 'black'
    },
    media: {
      margin: 0,
      width: "100%",
      height: "220px",
      backgroundSize: "contain",
      [theme.breakpoints.down('sm')]: {
        height: "170px",
      },
    },
    content: {
      padding: "10px 12px 14px",
      "&:last-child": {
        paddingBottom: 14,
      },
    },
    link: {
      textDecoration: 'none'
    }
  }),
);

interface IProps {
  product: ProductsData,
  language: string
}

const ProductCard: React.FC<IProps> = ({
  product,
  language
}) => {
  useEffect(() => { }, []);

  const classes = useStyles();
  const getMetricText = () => {
    const metrics: any = product?.metrics;
    if (!metrics) return '';
    if (typeof metrics === 'string') return metrics;

    const value = metrics.value || metrics;
    return value?.[language] || value?.lv || value?.en || metrics.code || '';
  };
  const metricText = getMetricText();

  return (
    <Link to={'/product/' + product.code} className={classes.link}>
      <Card classes={{ root: classes.card }}>
        <CardMedia
          className={classes.media}
          image={product?.image?.[0]?.img ? process.env.REACT_APP_IMAGE_HOST+'/files/product_images/' + product.image[0].img : ''}
        />
        <CardContent className={classes.content}>
          <Typography component="p" className={classes.manufacture}>
            {product?.supplier?.title || ''}
          </Typography>
          <Typography component="h3" className={classes.title}>
            {product?.title?.[language] || product?.title?.lv || product?.title?.en || ''}
          </Typography>
          <Typography className={classes.manufacture}>
            <FormattedMessage id="product.article" />: {product.article || ''}
          </Typography>
          <Typography className={classes.price}>
            <strong>€ {product.price ? parseFloat(product.price).toFixed(2) : ''}{metricText ? ` / ${metricText}` : ''}</strong>
          </Typography>
          {product.available ? (
            <Typography component="span" className={classes.available}>
              <Box pt={2}>
                <Grid container direction="row" alignItems="center">
                  <Grid item>
                    <CheckCircleOutline />
                  </Grid>
                  <Grid item>
                    <Box pb={0.7} pl={1}><FormattedMessage id="product.available" /></Box>
                  </Grid>
                </Grid>
              </Box>
            </Typography>
          ) : (
              <Typography component="span" className={classes.notAvailable}>
                <Box pt={2}>
                  <Grid container direction="row" alignItems="center">
                    <Grid item>
                      <ErrorOutline />
                    </Grid>
                    <Grid item>
                      <Box pb={0.7} pl={1}><FormattedMessage id="product.onRequest" /></Box>
                    </Grid>
                  </Grid>
                </Box>
              </Typography>
            )}
        </CardContent>
      </Card>
    </Link>
  );
};

export default (ProductCard);
